import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getInterest } from '../redux/actions/action-creator';


const Interest = ({ }) => {

    const dispatch = useDispatch();
    const { intrest = [] } = useSelector(state => state.common);

    const [selectedSubcategories, setSelectedSubcategories] = useState([]);

    // const News = [
    //     { path: '', newsimg: require('../assets/images/icons/Tech.png'), newsName: 'Tech' },
    //     { path: '', newsimg: require('../assets/images/icons/Crypto.png'), newsName: 'Crypto' },
    //     { path: '', newsimg: require('../assets/images/icons/Politics.png'), newsName: 'Politics' },
    //     { path: '', newsimg: require('../assets/images/icons/Health.png'), newsName: 'Health' },
    //     { path: '', newsimg: require('../assets/images/icons/Stocks.png'), newsName: 'Science' },
    //     { path: '', newsimg: require('../assets/images/icons/Space.png'), newsName: 'Space' },
    //     { path: '', newsimg: require('../assets/images/icons/Stocks.png'), newsName: 'Stocks & Investing' },
    //     { path: '', newsimg: require('../assets/images/icons/Personal.png'), newsName: 'Personal finance' },
    // ]
    // const Sports = [
    //     { id: 1, newsimg: require('../assets/images/icons/Tech.png'), newsName: 'Tech' },
    // ]

    useEffect(() => {
        // setScreenLoader(false);
        API_Function()
    }, []);

    const API_Function = () => {
        dispatch(getInterest()).then(response => {
            if (response?.status) { }
            else { }
        }).catch(error => {
            // setScreenLoader(false);
        }).finally(() => {
            // setScreenLoader(false);
        })
    }


    useEffect(() => {
        fetchInterestData();
    }, []);

    const fetchInterestData = () => {
        dispatch(getInterest())
            .then(response => {
                if (response?.status) {
                    // Handle success
                } else {
                    // Handle failure
                }
            })
            .catch(error => {
                // Handle error
            })
            .finally(() => {
                // This block will always execute regardless of success or failure
            });
    };



    const handleSubcategoryClick = (subcategoryId) => {
        const isSelected = selectedSubcategories.includes(subcategoryId);
        if (isSelected) {
            setSelectedSubcategories(prevSelected => prevSelected.filter(id => id !== subcategoryId));
        } else {
            setSelectedSubcategories(prevSelected => [...prevSelected, subcategoryId]);
        }
    };

    const handleSubmit = () => {
        // Use selectedSubcategories in your logic
        console.log("Selected Subcategories:", selectedSubcategories);
    };


    return (
        <div className='Login_screen'>
            <div className="Login_screen_con">
                <div className='login_fron_comaq Interest'>
                    <h1>Select Interest</h1>
                    <div className='Interest_blog'>
                        <div className='News_blog'>
                            <ul>
                                {intrest?.category_data.map((category, categoryIndex) => (
                                    <React.Fragment key={categoryIndex}>
                                        <h2>{category.category_name}</h2>
                                        {category.subcategories.length === 0 ? (
                                            <p>Data not found</p>
                                        ) : (
                                            <ul>
                                                {category.subcategories.map((subcategory, subcategoryIndex) => (
                                                    <li
                                                        key={subcategoryIndex}
                                                        onClick={() => handleSubcategoryClick(subcategory.subcategory_id)}
                                                        className={selectedSubcategories.includes(subcategory.subcategory_id) ? 'selected' : ''}
                                                    >
                                                        <span>{subcategory.subcategory_name}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </React.Fragment>
                                ))}
                            </ul>
                        </div>

                    </div>
                    <button className='logi_in_button' onClick={handleSubmit}>Submit</button>
                </div>

            </div >
        </div >
    )
}

export default Interest
